// This is used to determine if a user is authenticated and
// if they are allowed to visit the page they navigated to.

// If they are: they proceed to the page
// If not: they are redirected to the login page.
import React from 'react';
import {Redirect, Route} from 'react-router-dom';

// Redux
import {useSelector} from 'react-redux';

const NotAuthRoute = ({component: Component, ...rest}) => {
	// Redux
	const {authToken} = useSelector((state) => state.app);

	return (
		<Route
			{...rest}
			render={(props) =>
				authToken ? (
					<Redirect
						to={{pathname: '/home', state: {from: props.location}}}
					/>
				) : (
					<Component {...props} />
				)
			}
		/>
	);
};

export default NotAuthRoute;
